import React from 'react';
import PropTypes from 'prop-types';

const Cog = ({ color }) => (
  <svg viewBox="0 0 20 20">
    <path
      fill={color}
      d="M10 14c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm7.566-6.084c-.33-.123-.592-.386-.743-.754a1.295 1.295 0 0 1 0-1.039l.951-2.092a.434.434 0 0 0-.088-.487l-1.23-1.23a.435.435 0 0 0-.487-.088l-2.092.951c-.319.144-.687.145-1.054-.007a1.293 1.293 0 0 1-.74-.736L11.278.282A.436.436 0 0 0 10.87 0H9.13a.436.436 0 0 0-.407.282l-.807 2.152c-.123.33-.386.592-.754.743-.351.144-.72.144-1.039 0l-2.092-.951a.435.435 0 0 0-.488.088l-1.23 1.23a.434.434 0 0 0-.087.487l.951 2.092c.145.32.145.688-.006 1.054a1.294 1.294 0 0 1-.737.74l-2.152.806A.436.436 0 0 0 0 9.13v1.74c0 .18.113.343.282.407l2.153.807c.329.123.59.386.742.754.145.35.145.72 0 1.039l-.951 2.092a.434.434 0 0 0 .088.487l1.23 1.23a.434.434 0 0 0 .487.088l2.092-.951c.32-.144.688-.145 1.054.007.353.144.616.406.74.736l.806 2.152c.064.17.226.282.407.282h1.74a.436.436 0 0 0 .407-.282l.807-2.152c.123-.33.386-.592.754-.743.351-.144.72-.145 1.039 0l2.092.951c.165.076.36.04.488-.088l1.23-1.23a.434.434 0 0 0 .087-.487l-.951-2.092c-.145-.32-.145-.688.006-1.054.145-.353.407-.616.737-.74l2.152-.806A.436.436 0 0 0 20 10.87V9.13a.436.436 0 0 0-.282-.407l-2.152-.807z"
      fillRule="nonzero"
    />
  </svg>
);

Cog.propTypes = {
  color: PropTypes.string,
};

export default Cog;
